import React from 'react';
import { SectionHeading, SliderButton } from '../../../../ui';

export function LandingReviews() {
  return (
    <section className="section section--reviews content-width" id="reviews" data-figma-node="125:48307" aria-labelledby="reviews-title">
      <div className="reviews-heading">
        <SectionHeading
          title="Что говорят о LOVO"
          titleId="reviews-title"
          description="Реальные отзывы из Яндекс Карт и Google Maps — о сервисе и о конкретных перевозчиках"
        />
        <div className="reviews-score">
          <div>
            <strong>4.8</strong>
            <span className="star-row" aria-label="Рейтинг 4.8 из 5">
              <img src="/assets/figma/review-rating-star.svg" alt="" />
              <img src="/assets/figma/review-rating-star.svg" alt="" />
              <img src="/assets/figma/review-rating-star.svg" alt="" />
              <img src="/assets/figma/review-rating-star.svg" alt="" />
              <img src="/assets/figma/review-rating-star.svg" alt="" />
            </span>
          </div>
          <p>
            <a href="#reviews-list">Все отзывы на Яндекс Картах <img src="/assets/figma/button-arrow-up-right-brown.svg" alt="" /></a>
            <i></i>
            <a href="#reviews-list">Все отзывы на Google Maps <img src="/assets/figma/button-arrow-up-right-brown.svg" alt="" /></a>
          </p>
        </div>
      </div>

      <div className="reviews-list" id="reviews-list">
        <div className="review-tabs" role="tablist" aria-label="Фильтр отзывов">
          <button className="is-active" type="button"><img src="/assets/figma/review-tab-platform.svg" alt="" />О платформе · 247</button>
          <button type="button"><img src="/assets/figma/review-tab-car.svg" alt="" />О перевозчиках · 1842</button>
          <button type="button"><img src="/assets/figma/review-tab-random.svg" alt="" />Случайная подборка</button>
        </div>
        <div className="carousel-wrap">
          <div className="review-cards carousel" id="review-cards"></div>
        </div>
        <div className="slider-actions">
          <SliderButton direction="left" state="Default" data-scroll="prev" aria-label="Предыдущие отзывы" />
          <SliderButton direction="right" state="Default" data-scroll="next" aria-label="Следующие отзывы" />
        </div>
      </div>

      <blockquote className="featured-quote">
        <p>LOVO заметно лучше Авито<br />и telegram-каналов — есть<br />верификация перевозчиков,<br />портфолио с фото, отзывы.<br />Чувствуется доверие.</p>
        <footer><img src="/assets/landing/review-featured-avatar.webp" alt="" /><span><b>Алексей Иванов</b><small>14 мая 2026</small></span></footer>
      </blockquote>

      <div className="video-reviews">
        <div className="carousel-wrap">
          <div className="video-cards carousel" id="video-cards"></div>
        </div>
        <div className="slider-actions">
          <SliderButton direction="left" state="Default" data-scroll="prev" aria-label="Предыдущее видео" />
          <SliderButton direction="right" state="Default" data-scroll="next" aria-label="Следующее видео" />
        </div>
      </div>
    </section>
  );
}
